import { useEffect, useState } from "react";

const LeadCard = (props) => {
  const PERSONA = props?.$store?.persona;
  const [cardData, setCardData] = useState([]);
  const [timeline, setTimeline] = useState("TODAY");

  const fetchDashboardData = (query, params) => {
    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }

    if (PERSONA === _enum.ROUTE_PERSONAS.admin) {
      console.log(props.activetab);

      if (props.activetab === _enum.ROUTE_PERSONAS.admin) {
        props.apis.apiGetLeadsByStatus(payload).then(({ data, total }) => {
          let cards = {
            totalLeadsCount: total,
            totalApplied: data.filter((v) => v.status === "APPLIED")[0]?.count,
            totalDisbursed: data.filter((v) => v.status === "DISBURSED")[0]
              ?.count,
          };
          setCardData(cards);
        });
      }

      if (props.activetab === _enum.ROUTE_PERSONAS.telecaller) {
        props.apis
          .apiGetLeadsAssignedByCounts(payload)
          .then(({ data, total }) => {
            let cards = {
              totalLeadsCount: total,
              totalApplied: data.filter((v) => v.status === "APPLIED")[0]
                ?.count,
              totalDisbursed: data.filter((v) => v.status === "DISBURSED")[0]
                ?.count,
            };
            setCardData(cards);
          });
      }
    }

    if (PERSONA === _enum.ROUTE_PERSONAS.telecaller) {
      props.apis
        .apiGetLeadsAssignedByCounts(payload)
        .then(({ data, total }) => {
          let cards = {
            totalLeadsCount: total,
            totalApplied: data.filter((v) => v.status === "APPLIED")[0]?.count,
            totalDisbursed: data.filter((v) => v.status === "DISBURSED")[0]
              ?.count,
          };
          setCardData(cards);
        });
    }

    // if (PERSONA === _enum.ROUTE_PERSONAS.ops) {
    //   props.apis.apiGetLeadsByStatus(payload).then(({ data, total }) => {
    //     let cards = {
    //       totalLeadsCount: total,
    //       totalApplied: data.filter((v) => v.status === "APPLIED")[0]?.count,
    //       totalDisbursed: data.filter((v) => v.status === "DISBURSED")[0]
    //         ?.count,
    //     };
    //     setCardData(cards);
    //   });
    // }
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    // let val = value[0].key;
    // console.log({ value });
    // let payload = {};
    // if (val === "last_six_month") {
    //   payload.startDate = lastSixMonthDate;
    //   payload.endDate = endDate;
    // } else {
    //   payload.startDate = startDate;
    //   payload.endDate = endDate;
    // }
    // fetchDashboardData(payload);

    let val = value[0]?.key || "TODAY";
    let inputs = [
      "productinfo-column-start_date",
      "productinfo-column-end_date",
      "productinfo-column-search_btn",
      "productinfo-column-reset_btn",
    ];
    // console.log({ val });
    if (val === "CUSTOM") {
      showInputs(inputs);
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [timeline, props.activetab]);

  return (
    <>
      <div className="dashboard_card_container mb-4">
        <div className="metrics_card_row gcol-lg-3">
          <div className="leads_detail_select_box floating_box">
            <div className="row justify-content-end">
              <div className="col-12 col-md-3 col-xl-2">
                <AppInput
                  type="select"
                  options={_enum.OVERALL_DETAIL}
                  name="leads_detail"
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Select"
                  outerclass="mb-0"
                ></AppInput>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personCheckPinkIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.totalLeadsCount || 0}</h5>
              <div className="bottom_content">
                <p className="card-text pe-4">Total Leads</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.walletTealIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.totalApplied || 0}</h5>
              <div className="bottom_content">
                <p className="card-text">Total Applied</p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.moneyhandIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{cardData?.totalDisbursed || 0}</h5>
              <div className="bottom_content">
                <p className="card-text">Total Disbursed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(LeadCard);
